import dashboardRoutes from './router';
import Category from '../order/category/category';
import UserProfile from './user-profile/user-profile';
import ChangePassword from './change-password/change-password';
import EditProfile from './user-profile/edit';
import Settings from './settings/settings';
import TermsConditions from './static/terms-conditions';
import RulesFaq from './static/rules-faq';
import caWarn from './static/ca-warn';
import birdsCritters from './static/faq-birds-critters';
import franchising from './static/faq-franchising';
import productWarranties from './static/faq-product-warranties';
import privacy from './static/privacy';


export default angular.module('app.dashboard', [])
  .config(dashboardRoutes)
  .component('home', Category)
  .component('userProfile', UserProfile)
  .component('editProfile', EditProfile)
  .component('changePassword', ChangePassword)
  .component('settings', Settings)
  .component('termsConditions', TermsConditions)
  .component('rulesFaq', RulesFaq)
  .component('caWarn', caWarn)
  .component('birdsCritters', birdsCritters)
  .component('franchising', franchising)
  .component('productWarranties', productWarranties)
  .component('privacy', privacy);



// WEBPACK FOOTER //
// ./src/app/dashboard/main.js